export const saveFieldDetails = (fieldName, fieldGroupName, rowIndex, fieldDetails) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_CHANGED_FIELD',
      hasManyGroup: fieldGroupName,
      rowIndex: rowIndex,
      fieldName: fieldName,
      fieldDetails: fieldDetails,
    });
  };
};

export const deleteFieldGroup = (fieldGroup, fieldGroupIndex) => {
  return (dispatch) => {
    dispatch({
      type: 'DELETE_FIELD_GROUP',
      fieldGroup,
      rowIndex: fieldGroupIndex,
    });
  };
};

export const deleteField = (fieldName) => {
  return (dispatch) => {
    dispatch({
      type: 'DELETE_FIELD',
      fieldName,
    });
  };
};
